/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_EyebrowInputs */

const en_directory_guide_how_it_works_eyebrow = /** @type {(inputs: Directory_Guide_How_It_Works_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Seek AI works`)
};

const zh_directory_guide_how_it_works_eyebrow = /** @type {(inputs: Directory_Guide_How_It_Works_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 运作方式`)
};

/**
* | output |
* | --- |
* | "How Seek AI works" |
*
* @param {Directory_Guide_How_It_Works_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_eyebrow = /** @type {((inputs?: Directory_Guide_How_It_Works_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_eyebrow(inputs)
	return zh_directory_guide_how_it_works_eyebrow(inputs)
});
export { directory_guide_how_it_works_eyebrow as "directory.guide.how_it_works.eyebrow" }